<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'cloudServerManager' })"
            >云服管理</em
          >
          <label><i class="el-icon-arrow-right"></i> {{ title }}云服</label>
        </div>
      </div>
      <div class="content-inner-wrapper">
        <template v-if="status == 0">
          <h3>订单详情</h3>
          <el-form label-width="100px" label-position="right">
            <el-form-item label="订单内容：">
              {{ title }}云服（{{ txt }}）
            </el-form-item>
            <el-form-item label="购买数量：">
              {{ count }}
            </el-form-item>
            <el-form-item label="购买时长：">
              {{ day }}天<em v-show="subMoney"
                >（原价¥{{ oriMoney }}，限时折扣价¥{{ money }}）</em
              >
            </el-form-item>
            <el-form-item label="合计金额：">
              ¥{{ money }}<em v-show="subMoney">（已优惠¥{{ subMoney }}）</em>
            </el-form-item>
            <el-form-item label="订单编号：">
              {{ orderId }}
            </el-form-item>
            <el-form-item label="创建时间：">
              {{ createTime | formatTime }}
            </el-form-item>
          </el-form>
          <h3>支付方式</h3>
          <el-radio-group v-model="payType" size="mini">
            <el-radio-button type="primary" label="3">微信支付</el-radio-button>
            <el-radio-button type="primary" label="4">支付宝</el-radio-button>
          </el-radio-group>
          <div class="img-block">
            <img width="164px" height="164px" :src="qrcode" />
            <div class="expiredTips" v-if="!isValidCode" @click="getCode">
              <i class="el-icon-refresh-right"></i>
              <p>二维码已失效</p>
            </div>
          </div>
          <el-row>
            <el-col :span="4" :offset="19">
              <el-button class="backBtn" @click="$router.back()" type="info"
                >返回上一页</el-button
              >
            </el-col>
          </el-row>
        </template>
        <template v-else-if="status === 1">
          <div class="paySuccess">
            <i class="el-icon-success"></i>
            <h3>支付成功</h3>
            <p>
              请前往云服列表页查看及管理您的云服，设置游戏备份请前往迷你世界客户端
            </p>
            <el-link
              :underline="false"
              @click="$router.push({ name: 'cloudServerOrderList' })"
              >点击可查看订单>></el-link
            >
            <el-button @click="$router.push({ name: 'cloudServerManager' })"
              >返回主页</el-button
            >
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import { cloudApi } from '../../api/index';
import mixins from '../../mixins/pay.mixins';
const { getPayCode, getPayState } = cloudApi;
const EFFECT_TIME = 300000; // 5 minute
let timer = null;
let check_is_completed_timer = null;
const CHECK_COUNT = 100;
let checkedCount = 0;
export default {
  mixins: [mixins],
  data() {
    return {
      qrcode: '',
      codeStartTime: 0,
      isValidCode: true,
      sunBuyType: 1,
    };
  },
  watch: {
    payType: function () {
      this.getCode();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.resetTimer();
    next();
  },
  created() {
    this.getCode();
  },
  methods: {
    getCode() {
      getPayCode({
        buy_type: this.payType,
        id: this.orderId,
        sub_buy_type: this.sunBuyType,
      }).then(res => {
        if (res.code === 0) {
          this.resetTimer();
          this.codeStartTime = Date.now();
          this.generateQR(res.data.pay_url);
          this.isValidCode = true;
          timer = setInterval(() => {
            if (Date.now() - this.codeStartTime >= EFFECT_TIME) {
              this.isValidCode = false;
            }
          }, 1000);
          check_is_completed_timer = setInterval(() => {
            checkedCount++;
            if (checkedCount > CHECK_COUNT) {
              clearInterval(check_is_completed_timer);
              check_is_completed_timer = null;
              return;
            }
            getPayState({ id: this.orderId }).then(res => {
              if (res.code === 0) {
                if (res.data.state === 2) {
                  this.setCodeUnvalid();
                  this.resetTimer();
                  this.status = 1;
                }
              }
            });
          }, 3000);
        }
      });
    },
    setCodeUnvalid() {
      this.isValidCode = false;
    },
    resetTimer() {
      clearInterval(timer);
      clearInterval(check_is_completed_timer);
      timer = null;
      check_is_completed_timer = null;
    },
    async generateQR(text) {
      try {
        this.qrcode = await QRCode.toDataURL(text);
        console.log('qrcode', this.qrcode);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.content-inner-wrapper {
  h3 {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 25px;
    margin-bottom: 16px;
  }
  .el-form {
    margin-bottom: 28px;
  }
  .el-form-item {
    height: 28px;
    margin-bottom: 10px;
    ::v-deep .el-form-item__label,
    ::v-deep .el-form-item__content {
      font-size: 16px;
      line-height: 28px;
      height: 28px;
      color: #595959;
    }
    ::v-deep .el-form-item__content {
      color: #262626;
      em {
        color: #f7424e;
      }
    }
  }
  .el-radio-group {
    .el-radio-button {
      margin-right: 12px;
      ::v-deep .el-radio-button__inner {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e1e1e1;
        color: #323232;
        box-shadow: none;
      }
      ::v-deep &.is-active {
        .el-radio-button__inner {
          background: rgba(255, 204, 64, 0.1);
          border: 1px solid #ffcc40;
        }
      }
    }
  }
  .img-block {
    width: 160px;
    height: 160px;
    margin-top: 16px;
    border-radius: 4px;
    background: #f0f0f0;
    position: relative;
    .expiredTips {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 36px;
      font-weight: bold;
      cursor: pointer;
      p {
        font-size: 18px;
        margin-top: 8px;
      }
    }
  }
  .paySuccess {
    i {
      display: block;
      width: 140px;
      height: 140px;
      color: #59d040;
      font-size: 140px;
      margin: 168px auto 48px;
    }
    h3 {
      margin: 0 auto 22px;
      width: 101px;
      font-size: 20px;
      font-weight: bold;
      color: #262626;
      line-height: 28px;
      text-align: center;
    }
    p {
      margin: 0 auto 4px;
      text-align: center;
      width: 544px;
      height: 22px;
      font-size: 16px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #8c8c8c;
      line-height: 22px;
    }
    .el-link {
      width: 132px;
      margin: 0 auto 183px;
      text-decoration: none;
      text-align: center;
      display: block;
      font-size: 16px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #3b9aff;
      line-height: 22px;
    }
    .el-button {
      display: block;
      margin: 0 auto 30px;
      width: 201px;
      height: 50px;
      background: #fd9b21;
      border-radius: 8px;
      color: #fff;
      font-size: 20px;
    }
  }
}
.el-row {
  margin-bottom: 26px;
}
.backBtn {
  font-size: 20px;
  width: 201px;
  height: 50px;
  background: #d9d9d9;
  border-radius: 8px;
  border-color: #d9d9d9;
}
</style>
